import { render, staticRenderFns } from "./StrategicSurveyTable.vue?vue&type=template&id=6ed3c8dc&"
import script from "./StrategicSurveyTable.js?vue&type=script&lang=js&"
export * from "./StrategicSurveyTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports